import {useEffect, useRef, useState} from "react";
import {InventoryService} from "./Service";
import {UploadService} from "../../utils/UploadService";
import 'react-quill/dist/quill.snow.css';
import Select from "react-select";
import {SettingService} from "../setting/Service";
import {nanoid} from 'nanoid'
import {toast} from "react-hot-toast";


const AddProduct = () => {
    const service = new InventoryService();
    const uploadService = new UploadService();
    const settingService = new SettingService();
    const [name, setName] = useState('');
    const [code, setCode] = useState('');
    const [description, setDescription] = useState('');
    const [purchasePrice, setPurchasePrice] = useState(0);
    const [salePrice, setSalePrice] = useState(0);
    const [quantity, setQuantity] = useState(0);
    const [hsn, setHsn] = useState('');
    const [discount, setDiscount] = useState(0);
    const [minQuantity, setMinQuantity] = useState(0);
    const [category, setCategory] = useState<{ label: string, value: string } | null>(null);
    const [unit, setUnit] = useState<{ label: string, value: string } | null>(null);
    const [tax, setTax] = useState<{ label: string, value: string } | null>(null);
    const [categoryOptions, setCategoryOptions] = useState<{ label: string, value: string }[]>([]);
    const [unitOptions, setUnitOptions] = useState<{ label: string, value: string }[]>([]);
    const [taxTypeOptions, setTaxTypeOptions] = useState<{ label: string, value: string }[]>([]);

    // File Upload
    const [selectedfile, SetSelectedFile] = useState([]);
    const [Files, SetFiles] = useState([]);

    const filesizes = (bytes: any, decimals = 2) => {
        if (bytes === 0) return '0 Bytes';
        const k = 1024;
        const dm = decimals < 0 ? 0 : decimals;
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    }

    const InputChange = (e: any) => {
        // --For Multiple File Input
        let images = [];
        for (let i = 0; i < e.target.files.length; i++) {
            images.push((e.target.files[i]));
            let reader = new FileReader();
            let file = e.target.files[i];
            reader.onloadend = () => {
                // @ts-ignore
                SetSelectedFile((preValue: any) => {
                    return [
                        ...preValue,
                        {
                            id: nanoid(),
                            filename: e.target.files[i].name,
                            filetype: e.target.files[i].type,
                            fileimage: reader.result,
                            datetime: e.target.files[i].lastModifiedDate.toLocaleString('en-IN'),
                            filesize: filesizes(e.target.files[i].size),
                            file: file
                        }
                    ]
                });
            }
            if (e.target.files[i]) {
                reader.readAsDataURL(file);
            }
        }
    }


    const DeleteSelectFile = (id: any) => {
        if (window.confirm("Are you sure you want to delete this Image?")) {
            const result = selectedfile.filter((data: any) => data.id !== id);
            SetSelectedFile(result);
        } else {
            // alert('No');
        }

    }


    const DeleteFile = async (id: any) => {
        if (window.confirm("Are you sure you want to delete this Image?")) {
            const result = Files.filter((data: any) => data.id !== id);
            SetFiles(result);
        } else {
            // alert('No');
        }
    }


    useEffect(() => {
        const getCategories = async () => {
            const res = await service.allCategories();
            if (res) {
                const options = res.map((item: any) => {
                    return {
                        label: item.name,
                        value: item.id,
                    }
                });
                setCategoryOptions(options);
            }
        }
        getCategories();
    }, [])

    useEffect(() => {
        const getUnits = async () => {
            const res = await service.allUnits();
            if (res) {
                const options = res.map((item: any) => {
                    return {
                        label: `${item.name} (${item.symbol})`,
                        value: item.id
                    }
                });
                setUnitOptions(options);
            }
        }
        getUnits();
    }, [])



    const handleSubmit = async (e: any) => {
        e.preventDefault();
        toast.loading('Adding product...');
        const images = [];
        for (let i = 0; i < selectedfile.length; i++) {
            const res = await uploadImage((selectedfile[i] as any).file);
            if (res) {
                images.push(res);
            }
        }
        const data = {
            name: name,
            code: code,
            description: description,
            purchasePrice: purchasePrice,
            salePrice: salePrice ? salePrice : 0,
            quantity: quantity,
            hsn: hsn,
            discount: discount,
            minQuantity: minQuantity,
            category: category ? parseInt(category.value) : null,
            unit: unit ? parseInt(unit.value) : null,
            tax: tax ? parseInt(tax.value) : null,
            images: images,
        }
        const res = await service.addProduct(data);
        if (res) {
            toast.success('Product added successfully');
            e.target.reset();
            setName('');
            setCode('');
            setDescription('');
            setPurchasePrice(0);
            setSalePrice(0);
            setQuantity(0);
            setHsn('');
            setDiscount(0);
            setMinQuantity(0);
            setCategory(null);
            setUnit(null);
            setTax(null);
            SetSelectedFile([]);
            SetFiles([]);
        }
    }

    const uploadImage = async (file: any) => {
        const res = await uploadService.upload(file);
        return res.length > 0 ? res[0] : null;
    }

    useEffect(() => {
        const getTaxTypes = async () => {
            const res = await settingService.allTaxTypes();
            if (res) {
                const options = res.map((item: any) => {
                    return {
                        label: `${item.name} (${item.percentage}%)`,
                        value: item.id
                    }
                });
                setTaxTypeOptions(options);
            }
        }
        getTaxTypes();
    }, [])

    return (
        <>
            <div className="card mb-0">
                <div className="card-body">
                    <div className="page-header">
                        <div className="content-page-header">
                            <h5>Add Product</h5>
                        </div>
                    </div>
                    <form onSubmit={handleSubmit} className="row">
                        <div className="col-lg-12">
                            <div className="form-title">
                                <h5>General Information</h5>
                            </div>
                        </div>

                        <div className="col-lg-4 col-12">
                            <div className="input-block mb-3">
                                <label>Product Name <span className="text-danger">(required)</span></label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter product name"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                    required={true}
                                />
                            </div>
                        </div>
                        <div className="col-lg-4 col-12">
                            <div className="input-block mb-3">
                                <label>Product Code <span className="text-danger">(required)</span></label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter product code"
                                    value={code}
                                    onChange={(e) => setCode(e.target.value)}
                                    required={true}
                                />
                            </div>
                        </div>
                        {/*<div className="col-lg-4 col-12 mb-3">*/}
                        {/*    <label htmlFor="tax" className="form-label">Tax</label>*/}
                        {/*    <Select*/}
                        {/*        name="tax"*/}
                        {/*        options={taxTypeOptions}*/}
                        {/*        value={tax}*/}
                        {/*        menuPortalTarget={document.body}*/}
                        {/*        styles={{*/}
                        {/*            menuPortal: base => ({*/}
                        {/*                ...base,*/}
                        {/*                zIndex: 9999*/}
                        {/*            })*/}
                        {/*        }}*/}
                        {/*        onChange={setTax}/>*/}
                        {/*</div>*/}
                        {/*<div className="col-lg-6 col-12">*/}
                        {/*    <div className="input-block mb-3">*/}
                        {/*        <label>Purchase Price <span className="text-danger">(required)</span></label>*/}
                        {/*        <input*/}
                        {/*            type="number"*/}
                        {/*            className="form-control"*/}
                        {/*            placeholder="Enter product purchase price"*/}
                        {/*            value={purchasePrice}*/}
                        {/*            onChange={(e) => setPurchasePrice(parseFloat(e.target.value))}*/}
                        {/*            required={true}*/}
                        {/*        />*/}
                        {/*    </div>*/}
                        {/*</div>*/}
                        {/*<div className="col-lg-6 col-12">*/}
                        {/*    <div className="input-block mb-3">*/}
                        {/*        <label>Sale Price </label>*/}
                        {/*        <input*/}
                        {/*            type="number"*/}
                        {/*            className="form-control"*/}
                        {/*            placeholder="Enter product sale price"*/}
                        {/*            value={salePrice}*/}
                        {/*            onChange={(e) => setSalePrice(parseFloat(e.target.value))}*/}
                        {/*        />*/}
                        {/*    </div>*/}
                        {/*</div>*/}
                        {/*<div className="col-lg-6 col-12">*/}
                        {/*    <div className="input-block mb-3">*/}
                        {/*        <label>HSN Code <span className="text-danger">(required)</span></label>*/}
                        {/*        <input*/}
                        {/*            type="text"*/}
                        {/*            className="form-control"*/}
                        {/*            placeholder="Enter product HSN code"*/}
                        {/*            value={hsn}*/}
                        {/*            onChange={(e) => setHsn(e.target.value)}*/}
                        {/*            required={true}*/}
                        {/*        />*/}
                        {/*    </div>*/}
                        {/*</div>*/}
                        {/*<div className="col-lg-6 col-12">*/}
                        {/*    <div className="input-block mb-3">*/}
                        {/*        <label>Quantity <span className="text-danger">(required)</span></label>*/}
                        {/*        <input*/}
                        {/*            type="number"*/}
                        {/*            className="form-control"*/}
                        {/*            placeholder="Enter product quantity"*/}
                        {/*            value={quantity}*/}
                        {/*            onChange={(e) => setQuantity(parseFloat(e.target.value))}*/}
                        {/*            required={true}*/}
                        {/*        />*/}
                        {/*    </div>*/}
                        {/*</div>*/}
                        {/*<div className="col-lg-4 col-12 mb-3">*/}
                        {/*    <label htmlFor="category" className="form-label">Category</label>*/}
                        {/*    <Select*/}
                        {/*        name="category"*/}
                        {/*        options={categoryOptions}*/}
                        {/*        value={category}*/}
                        {/*        onChange={setCategory}/>*/}
                        {/*</div>*/}
                        {/*<div className="col-lg-4 col-12 mb-3">*/}
                        {/*    <label htmlFor="unit" className="form-label">Unit <span*/}
                        {/*        className="text-danger">(required)</span></label>*/}
                        {/*    <Select*/}
                        {/*        name="unit"*/}
                        {/*        options={unitOptions}*/}
                        {/*        value={unit}*/}
                        {/*        onChange={setUnit}/>*/}
                        {/*</div>*/}


                        {/*<div className="col-lg-6 col-12">*/}
                        {/*    <div className="input-block mb-3">*/}
                        {/*        <label>Minimum Quantity</label>*/}
                        {/*        <input*/}
                        {/*            type="number"*/}
                        {/*            className="form-control"*/}
                        {/*            placeholder="Enter minimum quantity"*/}
                        {/*            value={minQuantity}*/}
                        {/*            onChange={(e) => setMinQuantity(parseFloat(e.target.value))}*/}
                        {/*            required={true}*/}
                        {/*        />*/}
                        {/*    </div>*/}
                        {/*</div>*/}

                        <div className="col-lg-12">
                            <div className="btn-path text-end">
                                <a
                                    href="javascript:void(0);"
                                    className="btn btn-cancel bg-primary-light me-3"
                                    onClick={() => {
                                        window.history.back();
                                    }}
                                >
                                    Back
                                </a>
                                <button type="submit" className="btn btn-primary">
                                    Save Changes
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </>
    );
}

export default AddProduct;